import { Box } from "@mui/material";
// import InvitedCallLogs from "./InvitedCallLogs";
import MissedCallLogs from "./MissedCallLogs";

const MissedCalls = () =>{
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', height: '100%' }}>
            <MissedCallLogs />
            {/* <InvitedCallLogs /> */}
        </Box>
    )
}

export default MissedCalls;